<template>
  <el-card class="v_user_list">
    <div class="g-flex"  slot="header">
      <span>商家公告列表</span>
      <div class="g-flex-justify-end g-flex-1">
        <el-button size="mini" type="success" @click="setForm({}, 1)">新增公告</el-button>
      </div>
    </div>
    <!-- 搜索 -->
    <el-form :inline="true" size="mini" :model="query">
      <el-form-item>
        <el-select slot="label" v-model="query.search_key" placeholder="查询">
          <el-option label="公告标题" value="title"></el-option>
        </el-select>
        <el-row>
          <el-col :span="14">
            <el-input v-model="query.search_val" @keyup.enter.native="getList()" @clear="getList()" placeholder="请输入查找内容" clearable></el-input>
          </el-col>
          <el-col :span="4" :offset="1">
            <el-button type="info" @click="resetData">重置</el-button>
          </el-col>
          <el-col :span="4" :offset="1">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table stripe size="mini" v-loading="table.loading" :data="table.rows" border>
      <el-table-column label="公告ID">
          <template slot-scope="scope">
              <span>{{scope.row.id }}</span>
          </template>
      </el-table-column>
      <el-table-column label="公告标题" :show-overflow-tooltip="true">
        <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
      </el-table-column>
      <el-table-column label="状态" :show-overflow-tooltip="true">
        <template slot-scope="scope">
            <span class="g-red" v-if="scope.row.status == 0">禁用</span>
            <span class="g-green" v-if="scope.row.status == 1">正常</span>
          </template>
      </el-table-column>

      <!-- <el-table-column label="公告内容" width="200" :show-overflow-tooltip="true">
        <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
      </el-table-column> -->
      <el-table-column label="创建时间" :show-overflow-tooltip="true">
          <template slot-scope="scope">
              <span>{{formatDate(scope.row.create_time, 'yyyy-MM-dd hh:mm')}}</span>
          </template>
      </el-table-column>
      <el-table-column label="更新时间" :show-overflow-tooltip="true">
          <template slot-scope="scope">
              <span>{{formatDate(scope.row.modify_time, 'yyyy-MM-dd hh:mm')}}</span>
          </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="setForm(scope.row, 2)">编辑公告</el-button>
          <el-button size="mini" type="danger" @click="apiDelShopBulletinHandel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <buss-bulletin-list-pop ref="BussBulletinListPop" @emitSaveSuccess="getList"/>


    <el-pagination :page-sizes="[15, 30, 60, 100]" :page-size="query.limit" :total="table.total" :current-page.sync="query.page" @current-change="getList(false)" @size-change="sizeChange" small hide-on-single-page background layout="total, sizes, prev, pager, next, jumper"></el-pagination>
    
  </el-card>
</template>

<script>
  import { formatDate } from '@/utils/index.js';
  import { apiGetShopBulletinList, apiDelShopBulletin } from '@/utils/api.js'
  import BussBulletinListPop from './BussBulletinListPop.vue'
  export default {
    components: { BussBulletinListPop },
    data() {
      return {
        auth:{
          addBlack: this.$global.ApiList.includes(60),
          delBlack: this.$global.ApiList.includes(61),
        },
        platFormList: [],

        query: { search_key: 'title', search_val: '', platform_id: '',  page:1, limit: 15 },

        table:{ loading:false, total:0, rows:[] },

        form: false,
        radio: 1,
        areaCodeSelected: [],

        formData: {},

        templateDownUrl: '/upload/demo.xlsx'
      }
    },
    async created() {
      this.getList()
    },
    filters: {
      filtersSex(sex) {
        if(sex == 1) return '男'
        return '女'
      },
      filtersPlatName(id, list) {
      let obj = list.find(item => item.id == id)
      if(obj) return obj.title
      return ''
    },
    },
    methods: {
      formatDate,

      editClick(item) {
        console.log(item)
      },


      // 移出骗子库
      async apiDelShopBulletinHandel(item) {
        this.$confirm(`此操作将会删除"${item.title}"这条公告, 是否继续?`, '删除公告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.table.loading = true
          const { success, data } =  await apiDelShopBulletin({ id: item.id }).catch(() => this.table.loading = false)
          this.table.loading = false
          if(!success) return
          this.$message.success(data.msg)
          this.getList()
        }).catch(() => {});
      },

      async getList(pageInit = true) {
        if (pageInit) this.query.page = 1
        this.table.loading = true
        const { success, data } = await apiGetShopBulletinList(this.query).catch(() => this.table.loading = false)
        if(!success) return
        this.table.loading = false
        this.table.rows = data.rows
        this.table.total = data.total
      },

      //每页数量改变
      sizeChange(limit) {
        this.query.limit = limit
        this.getList()
      },

      //设置form 1新增 2编辑
      setForm(formData = { id: ''  }, status = 1) {
        if(!formData.id) return this.$refs.BussBulletinListPop.onShow({ id: '' }, status)
        this.formData = JSON.parse(JSON.stringify(formData))
        return this.$refs.BussBulletinListPop.onShow(this.formData, status)
      },
      // 点击重置
      resetData() {
        this.query = { search_key: 'title', search_val: '', platform_id: '',  page:1, limit: 15 },
        this.getList()
      },
      
    }
  }
</script>

<style lang="scss">
</style>